module.exports = __webpack_public_path__ + "img/pepe-coin-green-hero-banner.5264b0fb.webp";